<template>
  <section class="custom-login">
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-content modal-card login-card">
        <div class="container">
          <img src="@/assets/images/LogoRSSBO_Header.svg" class="login-logo"
            alt="Rudolf Steiner Schule Bochum">
          <div class="titles">
            <h3 class="subtitle login-title">Login für {{client.name}} </h3>
            <p>{{client.dbline}}</p>
          </div>
          <form>
            <b-field label="Name">
              <b-input placeholder="E-Mail"
              style="max-width: 500px;"
              type="email"
              v-model="user"
              icon="email"
              autocomplete="on">
              </b-input>
            </b-field>
            <b-field label="Passwort">
              <b-input placeholder="Passwort"
              @keyup.native.enter="login()"
              style="max-width: 500px;"
              type="password"
              v-model="password"
              icon="key"
              autocomplete="on">
              </b-input>
            </b-field>
          </form>
          <div @click="toggleForgot()" class="pointer">
            <p>Passwort vergessen?</p>
          </div>
          <button class="button" disabled>Abbrechen</button>
          <button class="button margin-button"
          @click="login()">Login</button>
        </div>
      </div>
    </div>
    <div class="modal is-active" v-if="forgotModal">
      <div class="modal-background"></div>
      <div class="modal-content modal-card login-card">
        <div class="container">
          <img src="@/assets/images/LogoRSSBO_Header.svg" class="login-logo"
            alt="Rudolf Steiner Schule Bochum">
          <h3 class="subtitle">Passwort vergessen</h3>
          <b-field label="E-Mail">
            <b-input placeholder="Bitte E-Mail eintragen." v-model="forgot_mail"></b-input>
          </b-field>
          <button class="button" @click="toggleForgot()">Abbrechen</button>
          <Button :text="'E-Mail senden'" :type="'zoom'" @click="forgot_pw()"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Button from '../components/Common/Button.vue';

export default {
  components: {
    Button,
  },

  mounted() {
    let client = '';
    if (this.$route.params.client) client = this.$route.params.client;
    else client = 'login';
    this.$store.dispatch('Clients/load_client', client).then(() => {
      this.loading = false;
    });
    this.loading = false;
  },

  data() {
    return {
      loading: true,
      forgotModal: false,
      user: '',
      password: '',
      forgot_mail: '',
    };
  },
  computed: {
    client() {
      return this.$store.getters['Clients/login_client'];
    },
  },
  methods: {
    login() {
      const payload = { user: this.user, password: this.password };
      this.$store.dispatch('User/login', payload).then((response) => {
        if (response) {
          this.$router.push('dashboard');
        } else {
          this.$buefy.toast.open({
            duration: 3000,
            message: 'Passwort oder Nutzername falsch',
            type: 'is-danger',
          });
        }
      });
    },
    toggleForgot() {
      this.forgotModal = !this.forgotModal;
    },
    microsoftLogin() {
      window.location.href = 'https://rss-bo.cotrios.de/api/auth_microsoft';
    },
    forgot_pw() {
      this.$store.dispatch('User/forgot_pw', this.forgot_mail).then((response) => {
        if (response) {
          this.$buefy.toast.open({
            message: 'E-Mail gesendet!',
            type: 'is-success',
          });
        } else {
          this.$buefy.toast.open({
            message: 'E-Mail konnte nicht geschickt werden.',
            type: 'is-danger',
          });
        }
      });
      this.forgotModal = !this.forgotModal;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-login {
  color: var(--theme-text);

  > .modal > .modal-background {
    background: var(--theme-background);
  }

  .login-card {
    color: var(--theme-text);
    background: var(--theme-surface);
    border: 1px solid var(--theme-border);
    border-radius: 15px;
    width: calc(100vw - 2rem);
    max-width: 24rem;
    padding: 28px;
    box-shadow: 0 12px 36px rgba(0, 0, 0, .08);
  }

  .container { width: 100%; }

  .login-logo {
    display: block;
    width: 100%;
    max-width: 280px;
    height: auto;
    margin: 0 auto 24px;
    padding: 12px;
    background: #fff;
    border-radius: 8px;
  }

  .titles { margin-bottom: 1rem; }
  .subtitle { color: var(--theme-text); }
  .login-title { margin-bottom: .5rem; }
  p { padding: .5rem 0; }
  .margin-button { margin-left: 1rem; }
  .pointer { cursor: pointer; color: var(--theme-text); }
  .pointer:hover { text-decoration: underline; }
}
</style>
